import './App.css';

import {Navigation} from './navbar/navbar.jsx';
import AnimalCrossing from "./pages/animalCrossing";
import Artworks  from "./pages/artworks";
import About from "./pages/about";
import {Route, Routes} from "react-router-dom";

function App() {
    return (
        <>
            <Navigation />
            <Routes>
                <Route exact path='/' element={<Artworks/>}/>
                <Route exact path='/designs' element={<AnimalCrossing/>}/>
                <Route exact path='/about' element={<About/>}/>
            </Routes>
        </>
    )
}

export default App;
